import React, { useEffect } from "react";
import Form, { InputSection } from "../../components/Form";
import { Field, Formik } from "formik";
import { DropDown, DropDownOptionsProps } from "../../../../ui/DropDown";
import Input, { NumberInput } from "../../../../ui/Input";
import { parseDropdown } from "../../../../utils/parseDropdown";
import { get } from "../../../../utils/get";

interface IProps {
  kpiOptions?: any;
  values?: any;
  setFieldValue: any;
}

const KpiParameters360 = ({ kpiOptions, values, setFieldValue }: IProps) => {
  useEffect(() => {
    if (get(values, "kpi")) {
    }
    return () => {};
  }, [values]);

  return (
    <Form>
      <InputSection>
        <Field
          name="kpi"
          placeholder="select kpi"
          dropdownLabel="KPI name"
          component={DropDown}
          width="96%"
          options={parseDropdown(kpiOptions)}
          isBordered={true}
          value={get(values, "kpi")}
        />
        <Field
          name="weight"
          component={Input}
          label="Weight"
          width="50%"
          placeholder="Weight"
        />
      </InputSection>
    </Form>
  );
};

export default KpiParameters360;
